import envService from "@/env.service";
import { metadataConfiguration } from "@spz/config";
import { initReactI18next as uiInitReactI18next } from "@spz/ui/i18n";
import i18next from "i18next";
import type { InitOptions } from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import {
  DEFAULT_LANGUAGE,
  type SupportedLanguage,
} from "./types/supported-language.types";

// In supervizor we have fr_FR and en_US as supported languages
// This function will parse the language code and return the supported language
// Useful for fr_BE, fr_CA, en_GB, etc.
export const parseLanguage = (lng: string | undefined): SupportedLanguage => {
  if (lng) {
    if (lng.startsWith("fr")) return "fr_FR";
    if (lng.startsWith("en")) return "en_US";
  }
  return DEFAULT_LANGUAGE;
};

export const changeLanguage = async (language: string) => {
  const i18nLanguage = parseLanguage(language);
  if (i18nLanguage !== i18next.language) {
    await i18next.changeLanguage(i18nLanguage);
  }
};

const versionedTranslationsUrl = `${envService.env.i18n.translationLabelsBaseUrl}/translations/${metadataConfiguration.translationVersion}`;

const i18nextConfig: InitOptions = {
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: ["fr_FR", "en_US"] as SupportedLanguage[],
  ns: [versionedTranslationsUrl, "/locales"],
  defaultNS: "/locales",
  fallbackNS: versionedTranslationsUrl,
  lng: parseLanguage(navigator.language || DEFAULT_LANGUAGE),
  interpolation: {
    escapeValue: false,
  },
  backend: {
    loadPath: `{{ns}}/{{lng}}.json?v=${BUILD_TIMESTAMP}`,
  },
  detection: {
    order: ["navigator"],
    caches: [],
  },
};

i18next
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(uiInitReactI18next)
  .init(i18nextConfig);

// Add development error handling
if (process.env.NODE_ENV === "development") {
  i18next.on("failedLoading", (lng, ns, msg) => {
    console.warn(`i18next failed loading: ${lng}`, msg);
  });
}

export default i18next;
